import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * @FilePath: /kitchen-offline-web/src/3DEngine/components/calloutLineCanvas/calloutLines.tsx
 * @Author: Yongchao Wang
 * @Date: 2021-12-21 13:22:20
 * @LastEditors: lixin jiang
 * @LastEditTime: 2022-01-27 14:05:36
 * @Description:
 */
/* eslint-disable no-param-reassign */
import { memo, useEffect } from 'react';
import calloutLineRender from './calloutLinesRender';
const CalloutCanvas = ({ width, height, engine3D, style, }) => {
    var _a;
    useEffect(() => {
        setTimeout(() => {
            var _a;
            if (((_a = engine3D === null || engine3D === void 0 ? void 0 : engine3D.calloutLineObj) === null || _a === void 0 ? void 0 : _a.renderType) && engine3D.showCalloutLines) {
                engine3D.callCalloutLines();
            }
        }, 10);
    }, [height]);
    useEffect(() => {
        var _a;
        if (((_a = engine3D === null || engine3D === void 0 ? void 0 : engine3D.calloutLineObj) === null || _a === void 0 ? void 0 : _a.renderType) && engine3D.showCalloutLines) {
            engine3D.callCalloutLines();
        }
    }, [(_a = engine3D === null || engine3D === void 0 ? void 0 : engine3D.calloutLineObj) === null || _a === void 0 ? void 0 : _a.renderType, engine3D === null || engine3D === void 0 ? void 0 : engine3D.calloutLineObj]);
    useEffect(() => {
        if (engine3D) {
            engine3D.onCameraPositionChange(() => calloutLineRender(engine3D.calloutLineObj));
        }
    }, [engine3D]);
    return (_jsx(_Fragment, { children: _jsx("canvas", { id: "calloutCanvas", width: width, height: height, style: Object.assign(Object.assign({}, style), { position: 'absolute', left: 0, pointerEvents: 'none' }) }, void 0) }, void 0));
};
// const isEqual = (prev, next) => {
//   console.log(prev, next);
// };
export default memo(CalloutCanvas);
